var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{attrs:{"id":"footer"}},[_c('p',[_c('router-link',{attrs:{"to":"/terms"}},[_vm._v("Vilkår for brug af persondata")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }